<template>
  <div class="container">
		<div class="filter-warpper">
			 <el-date-picker
				 v-model="date_range"
				 type="daterange"
				 align="right"
				 unlink-panels
				 range-separator="至"
				 start-placeholder="开始日期"
				 end-placeholder="结束日期"
				 :picker-options="pickerOptions2"
				 @change="handleChange"
			 >
    </el-date-picker>
		</div>

		<div id="chartWrapper" class="chart-wrapper"  ref="chartWrapper">
			<el-tabs type="border-card">
			<el-table :data="dataList">
			<el-table-column prop="date_ts" label="日期">
			</el-table-column>
			<el-table-column prop="identify_times" label="使用人数">
			</el-table-column>
			<el-table-column prop="swiping_card_times" label="刷卡人数">
			</el-table-column>
			</el-table>
			</el-tabs>
		</div>
  </div>
</template>
<script>
import { apiGetEateryUserTimes, apiGetBindUsers } from '@/api'
import { mapState, mapGetters } from 'vuex'
import util from '@/util/util'
import 'echarts/lib/chart/line'
require('echarts/lib/component/toolbox')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

export default {
  name: 'azSummary',
  data () {
    return {
      dateList: [],
      dataList: [],
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      date_range: [
        new Date(new Date().getTime() - 6 * 24 * 3600 * 1000),
        new Date()
      ]
    }
  },
  mounted () {
    this.handleChange()
  },
  methods: {
    drawLine () {
      let lineWrapper = this.$refs['chartWrapper']
      let chart = this.$echarts.init(lineWrapper)
      chart.setOption(this.chartOptions)
    },
    handleChange () {
      let that = this
      function dateList () {
        let [start_ts, end_ts] = that.date_range.map((data, index) => {
          return util.dateToUnixtimestamp(that.date_range[index], 0)
        })
        let dateList = [start_ts]
        let current_ts = start_ts
        while (current_ts < end_ts) {
          current_ts += 60 * 24 * 60
          dateList.push(current_ts)
        }
        return dateList.map((ts) => {
          return util.formateDate(new Date(ts * 1000)).slice(0, 10)
        })
      }
      this.dateList = dateList()
      this.getDateList()
    },
    async getDateList () {
      let that = this
      function getEateryUserTimes () {
        return apiGetEateryUserTimes({
          api_key: that.userinfo.api_key,
          eatery_id: that.userinfo.eatery_id,
          date_range: {
            start_ts: util.dateToUnixtimestamp(that.date_range[0], 0),
            end_ts: util.dateToUnixtimestamp(that.date_range[1], 0)
          }
        }).then(res => {
          return Promise.resolve(res.data)
        })
      }

      const getBindUsers = () => {
      	return apiGetBindUsers({ api_key: that.userinfo.api_key,
          eatery_id: that.userinfo.eatery_id,
          date_range: {
            start_ts: util.dateToUnixtimestamp(that.date_range[0], 0),
            end_ts: util.dateToUnixtimestamp(that.date_range[1], 0)
          }
        }).then(res => {
          return Promise.resolve(res.data)
        }).catch((e) => {
          console.log(e)
        })
      }
      let eateryUserTimes = await getEateryUserTimes()
      that.dataList = []
      let bindUsers = await getBindUsers()
      if (eateryUserTimes.length === 0) {
        this.dateList.forEach((date, index) => {
          that.$set(eateryUserTimes, index, {
            identify_times: 0,
            swiping_card_times: 0,
            wechatBindUsers: 0
          })
        })
      }
      console.log(eateryUserTimes)
      that.dataList = eateryUserTimes.map((data, index) => {
        if (!data.identify_times) {
          that.$set(data, 'identify_times', 0)
        }
        if (!data.swiping_card_times) {
          that.$set(data, 'swiping_card_times', 0)
        }
        if (bindUsers[index] && bindUsers[index].times) {
          that.$set(data, 'wechatBindUsers', bindUsers[index].times)
        } else {
          that.$set(data, 'wechatBindUsers', 0)
        }
        return data
      })
    }
  },
  computed: {
    userinfo () {
      return this.$store.getters.userinfo()
    },
    chartOptions () {
      let identifyList = []

      let bindUsersList = []

      let swipCardLsit = []
      this.dataList.forEach(data => {
        console.log(data)
        identifyList.push(data.identify_times)
        bindUsersList.push(data.wechatBindUsers)
        swipCardLsit.push(data.swiping_card_times)
      })
      return {
        title: {
          text: 'AZ入口流量统计',
          x: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['每日使用人次', '每日刷卡人次', '每日绑定人次'],
          x: 'right',
          orient: 'vertical',
          padding: [50, 50, 0, 0]

        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.dateList
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '每日使用人次',
            type: 'line',
            data: identifyList
          },
          {
            name: '每日刷卡人次',
            type: 'line',
            data: swipCardLsit
          },
          {
            name: '每日绑定人次',
            type: 'line',
            data: bindUsersList
          }
        ]
      }
    }
  },
  watch: {
    dataList: {
      handler () {
        this.drawLine()
        console.log('sdasdsa')
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
	.container {
		.chart-wrapper {
			width: 100%;
			height: 500px;
		}
	}
</style>
